import dlv from 'dlv';
import * as React from 'react';
import { EntityContext } from '../EntityContent/Shortcode';
import Markdown from '../Markdown';
function ContentByPath({ path }) {
    return (React.createElement(EntityContext.Consumer, null, entity => {
        if (!entity) {
            return null;
        }
        return React.createElement(Markdown, { source: dlv(entity, path) });
    }));
}
export function Overview() {
    return React.createElement(ContentByPath, { path: 'overview.md' });
}
export function Infrastructure() {
    return React.createElement(ContentByPath, { path: 'infrastructure.md' });
}
export function Position() {
    return React.createElement(ContentByPath, { path: 'position.md' });
}
export function Payment() {
    return React.createElement(ContentByPath, { path: 'payment.md' });
}
//# sourceMappingURL=common.js.map